import type React from 'react';

import { Button } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import * as styles from './styles';

import { CaptionDefault } from '@cobliteam/base-components';

export interface ControlButtonProps {
  Icon?: JSX.Element;
  text?: string;
  selected?: boolean;
  disabled?: boolean;
  noHover?: boolean;
  textClassName?: string;
  onClick: () => void;
  children?: React.ReactNode;
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const ControlButton = ({ Icon, text, disabled, textClassName, onClick, children }: ControlButtonProps) => {
  const handleClick = disabled ? undefined : onClick;

  if (Icon) {
    return <Button onClick={handleClick} variant='outlined' color='default' size='sm' icon={Icon} className='bg-white' />;
  }

  return (
    <Button onClick={handleClick} variant='outlined' color='default' size='sm' className='bg-white'>
      {text && <CaptionDefault className={cn(styles.controlButtonText, textClassName)}>{text}</CaptionDefault>}
      {children}
    </Button>
  );
};

export default ControlButton;
